/**
 * FieldControls — compact form wrappers for the witness validator.
 *
 * SPDX-License-Identifier: LicenseRef-Proprietary
 * Copyright (c) 2026 Invariant Holdings LLC
 */

import React from "react";
import { PanelSurface, panelTokens } from "@csk/demo-ui";

const ACCENT = "#22c55e";

interface FieldGroupProps {
  readonly label: string;
  readonly children: React.ReactNode;
}

export function FieldGroup({
  label,
  children,
}: FieldGroupProps): React.JSX.Element {
  return (
    <div className="px-3 py-2.5 bg-[rgba(6,8,16,0.5)] border border-[var(--ilg-border)] rounded-[10px]">
      <div className="text-[11px] text-[var(--ilg-muted)] font-mono tracking-[0.08em] uppercase mb-2">
        {label}
      </div>
      {children}
    </div>
  );
}

interface FieldToggleProps {
  readonly label: string;
  readonly value: boolean;
  readonly onChange: (next: boolean) => void;
  readonly helpWhenFalse?: string;
}

export function FieldToggle({
  label,
  value,
  onChange,
  helpWhenFalse,
}: FieldToggleProps): React.JSX.Element {
  return (
    <PanelSurface.Toggle
      checked={value}
      color={value ? ACCENT : panelTokens.accentAmber}
      description={!value ? helpWhenFalse : undefined}
      label={label}
      onChange={onChange}
    />
  );
}
